const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let initialized = false;

export function initAnalytics() {
    if (!GA_ID || initialized) return;
    initialized = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
}

export function trackEvent(name, params = {}) {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
}

export const trackCall = (location) =>
    trackEvent("call_click", { event_category: "conversion", location });

export const trackFormSubmit = (formName) =>
    trackEvent(formName, { event_category: "conversion" });
